import { render, staticRenderFns } from "./RightTabBar.vue?vue&type=template&id=43c38675&scoped=true"
import script from "./RightTabBar.vue?vue&type=script&lang=js"
export * from "./RightTabBar.vue?vue&type=script&lang=js"
import style0 from "./RightTabBar.vue?vue&type=style&index=0&id=43c38675&prod&lang=scss&scoped=true"
import style1 from "./RightTabBar.vue?vue&type=style&index=1&id=43c38675&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c38675",
  null
  
)

export default component.exports